const yup = require("yup");

const deleteRecord = yup.object({
  deleteRecord: yup.string().required("Delete is required"),
});
const folder = yup.object({
  title: yup.string().required("Title is required"),
  foldernumber: yup.string().required("Staff Folder Number/Staff ID is required"),
  status: yup.string().required("Status is required"),
  department: yup.string().required("Department is required"),
});

const create = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  maritalstatus: yup.string().required("Marital status is required"),
  dateofbirth: yup.string().required("Date of birth is a required fields"),
  emailaddress: yup.string().required("Email address is a required fields"),
  phonenumber: yup.string().required("Phonenumber is a required fields"),
});
const login = yup.object({
  emailaddress: yup.string().required("Email address is a required fields"),
  password: yup.string().required("Passwrod is a required field"),
});

module.exports = {
  create,
  deleteRecord,
  folder,
  login,
};
